export default {
  computed: {
    ...mapGetters(["channels"]),
    channel() { return this.channels.find(data => data.channelID === this.channelID) },
    channelID() { return this.$route.params.channelID },
    channelName() { return this.channel?.channelName },
  }
}